module.exports = __webpack_public_path__ + "static/media/tailai-2.e04106ae.jpg";